<template lang="pug">
v-table.tw-w-full.tw-block
	thead.tw-block
		tr
			th(
				v-if="thead"
				v-for="(colName, i) in thead"
				:key="i"
			).tw-text-center {{colName}}
	tbody.tw-block
		tr(
			v-if="postSale.movementDetails.toCredit"
			v-for="(credit, i) in postSale.movementDetails.toCredit"
			:key="i"
		)
			td(class="tw-basis-8/12") {{credit.description}}
			td {{credit.price}}
			td(v-if="!isMobile")

		tr(
			v-if="postSale.movementDetails.toDebit"
			v-for="(debit, i) in postSale.movementDetails.toDebit"
			:key="i"
		)
			td(class="tw-basis-8/12") {{debit.description}}
			td(v-if="!isMobile")
			td {{debit.price}}

	tfoot.tw-block
		tr.tw-block(v-if="!isMobile")
			td(class="tw-basis-8/12") {{$t("postsale.movement_detail.subtotal", "Subtotale")}}
			td {{postSale.movementDetails.subtotal.credit}}
			td {{postSale.movementDetails.subtotal.debit}}
		tr.tw-block
			th(class="tw-basis-8/12") {{$t("postsale.movement_detail.total", "Totale")}} ({{postSale.movementDetails.total.credit ? $t("postsale.movement_detail.to_receive", 'da ricevere') : $t("postsale.movement_detail.to_pay", 'da pagare')}})
			th {{postSale.movementDetails.total.credit}}
			th {{postSale.movementDetails.total.debit}}
</template>

<script setup>
import {computed, inject} from "vue";
import {useI18n} from "vue-i18n";
import {usePostSaleStore} from "@/stores/post-sale";


const i18n = useI18n();
const isMobile = inject('isMobile');
const postSale = usePostSaleStore();
const thead = computed(() => {
	if(!postSale.movementDetails) return ;
	return isMobile.value ? postSale.movementDetails.theadMobile : postSale.movementDetails.thead;
})
</script>


<style scoped>
table thead th {
	font-size: 1.2rem;
}
table thead th:not(:first-child) {
	text-align: center !important;
}
table tfoot td,
table tfoot th,
table tbody td:not(:first-child) {
	text-align: right !important;
}
table tfoot > tr {
	border-top-width: 2.5px !important;
	border-top-color: #999999 !important;
}
table tfoot tr:last-child th {
	font-size: 1rem;
}
table tfoot th {
	font-size: 1.2rem !important;
}
</style>